import React from 'react';
import { useAuth } from '../context/AuthContext';
import { appUrl, goTo } from '../lib/host';
import '../pages/Auth.css';

export default function NoAccess({ title = 'No access', message }) {
  const { logout } = useAuth();
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{title}</h2>
        {message && <div className="error-message">{message}</div>}
        <button className="submit-btn" onClick={() => goTo(appUrl('/select-org'))}>
          Choose another organization
        </button>
        <p className="auth-link">
          <button className="tcx-link-btn" onClick={async () => { await logout(); goTo(appUrl('/login')); }}>
            Log out
          </button>
        </p>
      </div>
    </div>
  );
}
